import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { AppService } from './AppService.class';
import { Observable } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class AutopaymentService extends AppService<any> {

  constructor(protected http:HttpClient) {
    super(http);
    this.appmod = "autopayment";
   }

   public getcards(type: any): Observable<any> {
    this.appmod = "profile";
    let result = super.getService(type);
    this.appmod = 'autopayment';
    return result;
  }
  public getamounts(type: any): Observable<any> {
    let temp = this.appmod
    this.appmod = "profile";
    let result = super.getService(type);
    this.appmod = temp;
    return result;
  }
  public getbalance(): Observable<any> {
    let temp = this.appmod
    this.appmod = "profile";
    let result = super.getService('detail');
    this.appmod = temp;
    return result;
  }

  // public addBalance(data: any): Observable<any> {
  //   this.appmod = "custom/addbalance";
  //   let result = super.saveService(data);
  //   this.appmod =  'autopayment';
  //   return result;
  // }
  // public addBalanceS(data: any): Observable<any> {
  //   this.appmod = "custom/addbalance";
  //   let result = super.saveService(data);
  //   this.appmod =  'autopayment';
  //   return result;
  // }
}
